import { createEvent, createStore } from 'effector';
import type { Socket } from 'socket.io-client';

import type { WebBootstrapResponse, WebSessionResponse } from '@/features/auth/types';
import type { SocketConnectionState } from '@/interfaces/SocketConnectionState';

export const sessionHydrated = createEvent<WebSessionResponse>();
export const bootstrapHydrated = createEvent<WebBootstrapResponse | null>();
export const socketStateChanged = createEvent<SocketConnectionState>();
export const socketHydrated = createEvent<Socket | null>();

export const $session = createStore<WebSessionResponse | null>(null).on(sessionHydrated, (_state, payload) => payload);

export const $bootstrap = createStore<WebBootstrapResponse | null>(null).on(bootstrapHydrated, (_state, payload) => payload);

export const $socketState = createStore<SocketConnectionState>('idle').on(socketStateChanged, (_state, payload) => payload);

export const $socket = createStore<Socket | null>(null).on(socketHydrated, (_state, payload) => payload);
